import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Platform,MenuController, ModalController} from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { consts, defined } from './appDefs';
import { AboutComponent } from './about/about.component';
import { StatusBar as SBCapStat } from '@capacitor/status-bar';
import { AppConfigService } from './app-config.service';
import { Capacitor } from '@capacitor/core';
import { AppRate } from '@awesome-cordova-plugins/app-rate';
const hideStatusBar = async () => {
  await SBCapStat.hide();
};
declare var window:any;
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {
  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private router:Router,
    public menu:MenuController,
    private modalCnt:ModalController,
    private appConfig:AppConfigService
  ) {
   
    this.initializeApp();
   

  }

  configBoards=[];
  showBoardConfig()
  {

  }
  getAllBoards()

  {
    let result=[];
    let myBoards=JSON.parse(localStorage.getItem(consts.MY_KEY_BOARDS));
    if (defined(myBoards) && myBoards)
    Object.keys(myBoards).forEach(a=>{

      let board=myBoards[a];
      board.boardLib=consts.MY_FUN_BOARD;
      result.push(board);
    })
   this.configBoards=result;
   return result;
  }
  async initializeApp() {
    let t=await this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      let app=this;
      //alert ("Platform ready called");
      this.appConfig.initDelayed();
        setTimeout(() => {
          app.splashScreen.hide();
        }, 1000);
        this.setupAppRate();
      })
      this.getAllBoards();  
 if (Capacitor.getPlatform()!='web')
 {
     // alert ("Getting Products");
      
      let result=await this.appConfig.getProducts();
     
      if (!this.appConfig.featureAvailable('synth'))
      {
       this.appConfig.accesss48Selected=true;
       if (!this.appConfig.access48())
       {
        if (!this.appConfig.featureAvailable('synth'))
        {
          alert ("Your initial free period after installation expired.")
          alert ("If you have already purchased, please wait for few minutes to restore the purchases");
             
        }

    }

      }
      
   }
   
  }
  identity(index,item)
  {
    return (item.id);
  }
  purchaseSubscription()
  {
    this.menu.close();
    this.router.navigate(['/purchase']);
   

  }
  openPurchases()
  {
    this.menu.close();
    this.router.navigate(['/purchases']);
  }
  showRecordings()
  {
    
  }
  gotoBoardConfig()
  {
    this.menu.close();
    this.router.navigate(['/config'])
  }
 
  showAbout()
  {
    this.menu.close();
     this.modalCnt.create({
      component:AboutComponent,
      cssClass: '../about/about.componnt.scss'
    }).then (modal=>{

    
    modal.present();
    });
  }


  setupAppRate()
  {
    let appUrl=null;
    if (Capacitor.getPlatform()=='android')
    {
     appUrl= {
      
        android: 'market://details?id=com.saregalabs.raagaboard',
     }
    }
    if (Capacitor.getPlatform()=='ios')
    {
    appUrl= {
        ios: '1611914223'
          }
    }
    if (appUrl)
    {

      AppRate.setPreferences({
        openUrl: function(url) {
          var safariAvailable = false;
      
          if (window.SafariViewController) {
            window.SafariViewController.isAvailable(function(available) {
              safariAvailable = available;
            });
          }
      
          if (!safariAvailable) {
             window.open(url, '_blank', 'location=yes');
          } else {
            window.SafariViewController.show(
              {
                url: url,
                barColor: "#0000ff", // on iOS 10+ you can change the background color as well
                controlTintColor: "#00ffff", // on iOS 10+ you can override the default tintColor
                tintColor: "#00ffff", // should be set to same value as controlTintColor and will be a fallback on older ios
              },
      
              // this success handler will be invoked for the lifecycle events 'opened', 'loaded' and 'closed'
              function(result) {
                console.log(result.event)
              },
      
              function(msg) {
                console.log("Error: " + msg);
              }
            );
          }
        },
        storeAppURL:appUrl
      });


    }

  }
  review()
  {
    AppRate.promptForRating();
    ;
    
  }
}
